var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllSchoolIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#EFEFF0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.003 52.376H18.17a.402.402 0 0 1-.411-.399V32.434c0-.191.186-.399.411-.399h.001l9.833-.034v20.375zM44.036 32h9.727c.234 0 .411.18.411.398v19.58c0 .209-.205.398-.411.398h-9.727V32z",
    fill: "#B5B5B5",
    stroke: "#383838",
    strokeWidth: 0.469
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2 40.706h-4.269a.402.402 0 0 1-.412-.399v-4.183c0-.19.186-.398.412-.398h4.27c.087 0 .192.045.28.13a.398.398 0 0 1 .131.268v4.218c0 .078-.04.168-.125.244a.442.442 0 0 1-.286.12zM25.2 48.614h-4.269a.402.402 0 0 1-.412-.398v-4.218c0-.217.178-.398.412-.398h4.27c.206 0 .411.189.411.398v4.183a.433.433 0 0 1-.411.434zM50.922 40.706h-4.27a.402.402 0 0 1-.412-.399v-4.183c0-.19.186-.398.412-.398h4.27c.225 0 .41.208.41.398v4.218c0 .174-.168.364-.41.364zM50.922 48.614h-4.27a.402.402 0 0 1-.412-.398v-4.218c0-.217.178-.398.412-.398h4.27c.233 0 .41.18.41.398v4.183c0 .261-.185.434-.41.434z",
    fill: "#E8E8E8",
    stroke: "#383838",
    strokeWidth: 0.469
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.964 20.88a.402.402 0 0 1-.411-.398v-6.89c0-.217.177-.398.411-.398.234 0 .412.181.412.399v6.924c0 .174-.169.364-.412.364z",
    fill: "#2D344B",
    stroke: "#383838",
    strokeWidth: 0.469
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.982 17.6v.012l.002.012c.02.194-.138.374-.377.374h-7.643a.402.402 0 0 1-.411-.398v-4.007c0-.218.177-.399.411-.399h7.607c.234 0 .411.181.411.399V17.6z",
    fill: "#FFDA80",
    stroke: "#383838",
    strokeWidth: 0.469
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.766 20.117h.002a.37.37 0 0 1 .425 0h.001l8.073 5.202.008.005c.1.059.172.187.172.326v26.302c-.064.275-.246.424-.412.424h-16.11a.402.402 0 0 1-.411-.399V25.65c0-.118.055-.23.189-.337l8.063-5.196z",
    fill: "#D9D9D9",
    stroke: "#383838",
    strokeWidth: 0.469
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.955 55.926H15.046a.402.402 0 0 1-.411-.398v-3.55c0-.218.177-.4.411-.4h41.909c.233 0 .411.182.411.4v3.55a.402.402 0 0 1-.411.398z",
    fill: "#8B8B8B",
    stroke: "#383838",
    strokeWidth: 0.469
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.126 52.024h-8.324a.402.402 0 0 1-.411-.398V38.479c0-.217.177-.398.411-.398h8.324c.234 0 .412.18.412.398v13.167a.42.42 0 0 1-.412.378z",
    fill: "#EFEFF0",
    stroke: "#383838",
    strokeWidth: 0.469
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.964 52.024a.402.402 0 0 1-.411-.398V38.48c0-.218.177-.399.411-.399.234 0 .412.181.412.399V51.66c0 .174-.169.363-.412.363z",
    fill: "#2D344B",
    stroke: "#383838",
    strokeWidth: 0.469
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.647 31.107a2.334 2.334 0 0 1 2.345-2.33c1.312 0 2.381 1.056 2.381 2.33 0 1.273-1.07 2.328-2.381 2.328-1.274 0-2.345-1.052-2.345-2.329z",
    fill: "#FFE6AA",
    stroke: "#383838",
    strokeWidth: 0.469
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllSchoolIllustration);
export default __webpack_public_path__ + "static/media/all-school-illustration.eaf637cd9ac3c8870de045877fa90a24.svg";
export { ForwardRef as ReactComponent };